import DogCard from 'components/DogCard';
import ErrorAlert from 'components/ErrorAlert';
import { DataContext } from 'hooks/HeaderContext';
import React, { FC, useContext } from 'react';


const DogList: FC = () => {

    const {
        loading,
        filteredDogsList,
        dogListError,
    } = useContext(DataContext);


    return (
        <React.Fragment>
            {!loading && filteredDogsList?.length === 0 &&
                <h1>No results matching your criteria. Consider broadening your search.</h1>
            }
            <div className='row g-3' id="dog-photo-list">
                {dogListError &&
                    <ErrorAlert error={dogListError} showAlert={true} alertType={'danger'} />
                }
                {!dogListError &&
                    <>
                        {filteredDogsList.map(dog =>
                            <DogCard dog={dog} key={dog.id} />
                        )}
                    </>

                }
            </div>
        </React.Fragment>

    )
}

export default DogList;




















